import { useGetApartmentsMutation, useGetArchivedApartmentsMutation, useToggleArchiveApartmentMutation } from '@services/member/apartment/apartment.endpoints';
import { ApartmentTable } from '@services/member/apartment/apartment.types';
import { PaginationMetadata } from '@services/providers/cosem.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

export const useListPageVM = () => {

    const MySwal = withReactContent(Swal);

    const [totalApartments, setTotalApartments] = useState<number>(0);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const columnHelper = createColumnHelper<ApartmentTable>();
    const navigate = useNavigate();
    const [needReload, setNeedReload] = useState<boolean>();

    const [toggleArchiveApartment, { isSuccess: isToggleArchiveApartmentSuccess, isLoading: isToggleArchiveApartmentLoading }] = useToggleArchiveApartmentMutation();

    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedApartmentsMutation : useGetApartmentsMutation;
    }, [isArchived]);

    useEffect(() => {
        setTotalApartments(0);
    }, [isArchived]);

    useEffect(() => {
        if (isToggleArchiveApartmentSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isToggleArchiveApartmentSuccess]);
    

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalApartments(metadata.total);
        }
    };

    const handleToggleArchiveApartment = (id: number, archive: boolean) => {
        MySwal.fire({
            title: archive ? 'Êtes-vous sûr de vouloir archiver ce logement ?' : 'Êtes-vous sûr de vouloir désarchiver ce logement ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonText: 'Annuler',
        }).then((result) => {
            if (result.isConfirmed) {
                toggleArchiveApartment({ id, archived: archive });
            }
        })
    }

    const handleToggleArchiveApartments = (lines: ApartmentTable[], archive: boolean) => {
        MySwal.fire({
            title: archive ? 'Êtes-vous sûr de vouloir archiver ces logements ?' : 'Êtes-vous sûr de vouloir désarchiver ces logements ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonText: 'Annuler',
        }).then((result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchiveApartment({ id: line.id, archived: archive });
                });
            }
        })
    }

    return {
        handleToggleArchiveApartment,
        handleToggleArchiveApartments,
        handleMetadata,
        navigate,
        columnHelper,
        isArchived,
        mutationHook,
        setIsArchived,
        totalApartments,
        isLoading: isToggleArchiveApartmentLoading,
        needReload
    };
};
